import { PromoCodesList as PromoCodesListComponent } from 'components/promoCodes/PromoCodesList/PromoCodesList'

export const PromoCodesList: React.FC = () => {
  return <PromoCodesListComponent />
}
